import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getReferrals, GetReferralsParams} from '../api';
import {QUERY__REFERRALS} from '../queryKeys';
import {ReferralRecord} from '../types';

export const useGetReferrals = <SelectedData = GetListOutput<ReferralRecord>>(
  params?: GetReferralsParams,
  options?: QueryOptionsForList<ReferralRecord, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__REFERRALS, params],
    queryFn: () => getReferrals(params),
    ...options,
  });
};
